import { Navigate, Outlet } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client/react'
import { user } from '@cache'
import { storeReturnUrl } from '@utils/auth/returnUrl'

function PrivateRoute() {
  const currentUser = useReactiveVar(user)

  if (!currentUser) {
    storeReturnUrl()

    return <Navigate to='/login' />
  }

  return <Outlet />
}

export default PrivateRoute
